export default "__VITE_ASSET__01bac0d2__"